module.exports = __webpack_public_path__ + "img/logo.733fa7ee.svg";